// extracted by mini-css-extract-plugin
module.exports = {"controls":"NameEdit_controls__1Nv96","field":"NameEdit_field__2101z","wrapper":"NameEdit_wrapper__3jR6B"};